<template>
  <div class="wrap" style="overflow: hidden">
    <div class="content">
      <yd-cell-group>
        <yd-cell-item>
          <span slot="left">用户名：</span>
          <input slot="right" v-model="username" type="text" placeholder="请输用户名" />
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">密码：</span>
          <input slot="right" v-model="password" type="password" placeholder="请输入密码" />
        </yd-cell-item>
      </yd-cell-group>
      <div>
        <yd-button type="primary" @click.native="login">登录</yd-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
  name: "CheckLogin",
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    login() {
      if (this.username == "") {
        this.$dialog.toast({ mes: "请输入用户名", timeout: 1500 });
        return;
      }
      if (this.password == "") {
        this.$dialog.toast({ mes: "请输入密码", timeout: 1500 });
        return;
      }
      axios({
        method: "get",
        url:
          baseUrl +"checkLogin?username=" +this.username +"&password=" +this.password
      }).then(resp => {
        if (resp.data.error_code == "0") {
          debugger
          window.localStorage.setItem("checkUserId", resp.data.data);
          this.$router.push({ path: "/checkIndex" });
        } else {
          this.$dialog.toast({ mes: "用户名或密码错", timeout: 1500 });
        }
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.wrap /deep/ .yd-tab-nav .yd-tab-active {
  color: rgba(47, 111, 255, 1) !important;
}
.wrap /deep/ .yd-preview-footer:before {
  height: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/check-login.vue